import React, { useEffect, useState } from "react";
import { LoadingComponent } from "../../../Components/Loading";
import { Woo } from "../../../Helpers/Woo";
import { applyShopConfig } from "../../../Helpers/applyShopConfig";
import Context from "../../../Shared/Context/GlobalContext";
import { useLocalStorage } from "../../../Shared/Hooks/useLocalStorage";

const LS_KEY_MESSAGES = "loadingMessages";

export const DecoratedApp = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const ls = useLocalStorage();

  useEffect(() => {
    setLoading(true);
    Woo.domain.hello().then((data) => {
      applyShopConfig(data.shop);
      setData(data);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }).catch(() => {
      setLoading(false);
    });

    Woo.products.all()
      .then((products) => {
        ls.setJSON("products", products);
      })
      .catch((e) => {
        console.warn(e);
      });
  }, []);

  const hasCache = !!ls.getJSON(LS_KEY_MESSAGES)?.length;

  return (
    <Context.Provider data={data}>
      {loading && !data && !hasCache
        ? null
        : loading
        ? <LoadingComponent />
        : children(data)}
    </Context.Provider>
  );
};
